module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": _vm.placeholder ? _vm.placeholder : 'Gõ để tìm kiếm',
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', _vm.value)
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.clients), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": ((item.name) + " - " + (item.shop_name)),
        "value": item.id
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab66919"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/SelectClient.vue
// module id = 633
// module chunks = 1